import React from "react";

const ChannelItem = ({ channel, selectChannel, index }: { channel: any, selectChannel: any, index: number }) => {
  return (
    <div
      className={`channel-item ${channel.selected ? "selected-channel" : ""}`}
      onClick={() => selectChannel(channel, index)}
    >
      <span className="channel-name">{channel.name}</span>
      <span
        className="channel-status"
        style={{ backgroundColor: channel.color }}
      />
    </div>
  );
};

export default ChannelItem;
